import {Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';

import {AppComponent} from '../app.component'

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';
import {EditSuggestionComponent} from '../edit-suggestion/edit-suggestion.component';
import {ViewUserComponent} from '../view-user/view-user.component';

import {MatDialog} from '@angular/material';

import swal from 'sweetalert2';

import {FacebookService, UIParams, UIResponse} from 'ngx-facebook';

@Component({
    selector: 'app-all-suggstions',
    templateUrl: './all-suggstions.component.html',
    styleUrls: ['./all-suggstions.component.css'],
    providers: [HttpService, NotificationService]
})
export class AllSuggstionsComponent implements OnInit {

    public apiUrl = environment.apiUrl;


    public imagesToShow;

    public allBrands;

    public sortValue: string = '';

    public showImagesModalBool = false;

    public parentBrandData;

    public User_Details: any;
    public allSuggestions;

    public showType: string = 'suggestions';


    public brandToShowSuggestionsFor;

    public brandOptions = [];
    public filterOptions = {
        brand: 0
    }

    public reverse: boolean = false;

    public currentPage = 1;

    public filteredBrand;

    constructor(
        public http: HttpService,
        public notification: NotificationService,
        public app: AppComponent,
        public dialog: MatDialog,
        private fb: FacebookService
    ) {


    }

    ngOnInit() {
        this.getSuggestionsData(this.currentPage)

    }

    getSuggestionsData(page = 1, reported = 0) {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        if (this.User_Details.role.id == 1) {
            this.app.loading = true;
            this.http.makeRequestPost([
                `admin/user/suggestion/getallsuggestions?page=${page}`,
                {
                    token: this.User_Details.token,
                    reported
                }
            ])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        this.allSuggestions = response.data.suggestions;
                        this.brandOptions = response.data.brands;
                        this.brandOptions.unshift({name: 'All', id: 0});

                        document.body.scrollTo({top: 0, behavior: 'smooth'});
                        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});

                    }
                    if (response.error) {
                        this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                    }
                },
                (error) => {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            )
        } else {

            this.app.loading = true;
            this.http.makeRequestPost([
                `brand/admin/suggestion/get?page=${page}`,
                {
                    token: this.User_Details.token,
                    id: this.User_Details.brandadmins[0].id,
                    reported
                }
            ])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        this.allSuggestions = response.data.suggestions;
                        this.brandOptions = response.data.brands;
                        this.brandOptions.unshift({name: 'All', id: 0});
                        document.body.scrollTo({top: 0, behavior: 'smooth'});
                        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
                    }
                    if (response.error) {
                        this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                    }
                },
                (error) => {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            )
        }
    }

    getSuggestionsDataBrand(page = 1, brand, reported = 0) {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        if (this.User_Details.role.id == 1) {
            this.app.loading = true;
            this.http.makeRequestPost([
                `brand/admin/suggestion/get?page=${page}`,
                {
                    token: this.User_Details.token,
                    id: brand,
                    reported
                }
            ])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        this.allSuggestions = response.data.suggestions;
                        this.brandOptions = response.data.brands;
                        this.brandOptions.unshift({name: 'All', id: 0});

                        document.body.scrollTo({top: 0, behavior: 'smooth'});
                        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});

                    }
                    if (response.error) {
                        this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                    }
                },
                (error) => {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            )
        } else {

            this.app.loading = true;
            this.http.makeRequestPost([
                `brand/admin/suggestion/get?page=${page}`,
                {
                    token: this.User_Details.token,
                    id: this.User_Details.brandadmins[0].id,
                    reported
                }
            ])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        this.allSuggestions = response.data.suggestions;
                        this.brandOptions = response.data.brands;
                        this.brandOptions.unshift({name: 'All', id: 0});
                        document.body.scrollTo({top: 0, behavior: 'smooth'});
                        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
                    }
                    if (response.error) {
                        this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                    }
                },
                (error) => {
                    this.app.loading = false;
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            )
        }
    }

    markNotAbusive(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to mark this suggestion as not abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/markNotAbusive',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 0 && resp.data.abusive == 0) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                this.notification.showNotification('The suggestion has been marked as not abusive', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not mark the suggestion as not abusive', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    markAbusive(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to mark this suggestion as abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/markAbusive',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 1 && resp.data.abusive == 1) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                this.notification.showNotification('The suggestion has been marked as abusive', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not mark the suggestion as abusive', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    showUserDetails(user) {
        console.log(user);

        let dialogRef = this.dialog.open(ViewUserComponent, {
            width: '100vw',
            height: '100vh',
            data: {userDetails: user}
        });

        dialogRef.afterClosed().subscribe((result) => {


        });

    }


    reportSuggestion(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to report this suggestion as abusive?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['brand/admin/suggestion/report',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.reported == 1) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }

                                this.notification.showNotification('The suggestion has been reported', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not report the suggestion', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        });
    }

    rewardSuggestion(suggestion) {
        console.log('rewardSuggestion called');
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to reward the user for this suggestion?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/awesome_award.svg',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            console.log(data);
            if (data.value) {
                this.app.loading = true;
                this.http.makeRequestPost(['brand/admin/suggestion/reward',
                    {
                        token: this.User_Details.token,
                        id: suggestion.id
                    }])
                .subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            if (resp.data.rewarded == 1) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions[i] = resp.data;
                                    }
                                }
                                swal({
                                    title: 'You\'ve awarded  ' + resp.data.user[0].name + '.',
                                    text: 'Please contact ' + resp.data.user[0].name + ' directly on ' + resp.data.user[0].email + ' to reward them. ',
                                    type: 'warning',
                                    showCancelButton: false,
                                    confirmButtonText: 'Ok',
                                    buttonsStyling: false,
                                    imageUrl: 'assets/img/Popup_Squirrel.png',
                                    imageWidth: 100,
                                    showCloseButton: false,
                                    animation: false,
                                    confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
                                    cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
                                    reverseButtons: false
                                }).then((data) => {
                                    if (data.value) {
                                        swal({
                                            title: 'Share?',
                                            text: 'Would you like to share this on your brand Facebook page?',
                                            type: 'warning',
                                            showCancelButton: true,
                                            confirmButtonText: 'Yes',
                                            buttonsStyling: false,
                                            imageUrl: 'assets/img/Popup_Squirrel.png',
                                            imageWidth: 100,
                                            showCloseButton: true,
                                            animation: false,
                                            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
                                            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
                                            reverseButtons: true
                                        }).then((data) => {
                                            if (data.value) {
                                                if (suggestion.photos.length > 0) {
                                                    const options: UIParams = {
                                                        method: 'share',
                                                        quote: suggestion.user[0].name + ' ' + suggestion.user[0].surname + ' ' + 'has been rewarded for their suggestion: ' + suggestion.description + ' to the brand: ' + suggestion.brand[0].name + ' @[{10216349012700562}:{xander hattingh}]',
                                                        href: environment.apiUrl + 'get_image/' + suggestion.photos[0].image_path,
                                                    };
                                                    this.fb.ui(options)
                                                    .then(
                                                        (res: UIResponse) => {
                                                            console.log('Got the users profile', res);
                                                        })
                                                    .catch((error) => {
                                                        this.notification.showNotification('Unable to share', 'Error', 'error');
                                                    });
                                                } else {
                                                    const options: UIParams = {
                                                        method: 'share',
                                                        quote: suggestion.user[0].name + ' ' + suggestion.user[0].surname + ' ' + 'has been rewarded for their suggestion: ' + suggestion.description + ' to the brand: ' + suggestion.brand[0].name + ' @[{10216349012700562}:{xander hattingh}]',
                                                        href: environment.apiUrl + 'get_image/suggestion.jpg',
                                                    };
                                                    this.fb.ui(options)
                                                    .then(
                                                        (res: UIResponse) => {
                                                            console.log('Got the users profile', res);
                                                        })
                                                    .catch((error) => {
                                                        this.notification.showNotification('Unable to share', 'Error', 'error');
                                                    });
                                                }
                                            }
                                        }).catch(swal.noop);

                                        this.notification.showNotification('The user has been rewarded', 'Success', 'success');
                                    }
                                }).catch(swal.noop);

                                this.notification.showNotification('The user has been rewarded', 'Success', 'success');
                            } else {
                                this.notification.showNotification('Could not reward the user for the suggestion', 'Error', 'error');
                            }
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }
        })

    }

    editSuggestion(suggestion) {
        let dialogRef = this.dialog.open(EditSuggestionComponent, {
            width: '100vw',
            data: {suggestionDetails: suggestion, allBrands: this.brandOptions}
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result.changedSuggestion) {
                    for (var i = 0; i < this.allSuggestions.length; i++) {
                        if (this.allSuggestions[i].id == suggestion.id) {
                            this.allSuggestions[i] = result.changedSuggestion;
                        }
                    }
                }
            }

        });
    }

    deleteSuggestion(suggestion) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to delete this suggestion?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                console.log('delete the suggestion');
                console.log(suggestion);
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/suggestion/delete', {token: this.User_Details.token, id: suggestion.id}])
                .subscribe(
                    (response) => {
                        this.app.loading = false;
                        if (response.data) {
                            if (response.data.length != 0) {
                                for (var i = 0; i < this.allSuggestions.length; i++) {
                                    if (this.allSuggestions[i].id == suggestion.id) {
                                        this.allSuggestions.splice(i, 1);
                                    }
                                }
                            } else {
                                this.notification.showNotification('Could not delete the suggestion', 'Error', 'error');
                            }
                        }
                        if (response.error) {
                            this.notification.showNotification('Could not delete the suggestion', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }

        })
    }

    setShowType(value: string) {
        console.log(value);
        this.showType = value;
    }

    onLinkClick(evt) {
        console.log(evt.tab.textLabel.toLowerCase());
        this.showType = evt.tab.textLabel.toLowerCase();
        if (evt.tab.textLabel.toLowerCase() == 'reported') {
            if (!this.filteredBrand) {
                this.getSuggestionsData(0, 1);
            } else {
                this.getSuggestionsDataBrand(0, this.filteredBrand, 1);
            }
        } else {
            if (!this.filteredBrand) {
                this.getSuggestionsData(0, 0);
            } else {
                this.getSuggestionsDataBrand(0, this.filteredBrand, 0);
            }
        }
        // .textLabel.toLowerCase()
        // this.showType = value;
    }


    showImagesModal(photos) {
        this.showImagesModalBool = true;
        this.imagesToShow = photos;
    }

    toggleShowOptions(suggestion) {
        if (suggestion.showOptions == true) {
            suggestion.showOptions = false;
        } else {
            for (var i = 0; i < this.allSuggestions.length; i++) {
                this.allSuggestions[i].showOptions = false;
            }

            suggestion.showOptions = true;
        }
    }

    toggleBrandParentOptions(brand) {
        if (brand.showParentOptions == true) {
            brand.showParentOptions = false;
        } else {
            for (var i = 0; i < this.allBrands.length; i++) {
                this.allBrands[i].showParentOptions = false;
            }

            brand.showParentOptions = true;
        }
    }

    showBrandSuggestions(brand) {
        this.app.loading = true;
        this.http.makeRequestPost([
            'brand/admin/suggestion/get',
            {
                token: this.User_Details.token,
                id: brand.id
            }
        ])
        .subscribe(
            (response) => {
                this.app.loading = false;
                if (response.data) {
                    this.allSuggestions = response.data.suggestions;
                    this.brandToShowSuggestionsFor = brand;
                    brand.showOptions = false;
                }
                if (response.error) {
                    this.notification.showNotification('Could not get all suggestions', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    showChildBrands() {
        delete (this.brandToShowSuggestionsFor);
    }


    setTypeToShow(evt) {
        console.log(evt);
    }

    dismissall() {
        for (var i = 0; i < this.allSuggestions.length; i++) {
            this.allSuggestions[i].showOptions = false;
        }
    }

    loadPage(evt) {
        this.currentPage = evt;
        if (!this.filteredBrand) {
            this.getSuggestionsData(evt);
        } else {
            this.getSuggestionsDataBrand(evt, this.filteredBrand)
        }

    }

    brandChanged(evt) {
        console.log(evt);
        this.filteredBrand = evt;
        this.currentPage = 1;
        this.getSuggestionsDataBrand(1, evt)
    }
}



// WEBPACK FOOTER //
// ./src/app/all-suggstions/all-suggstions.component.ts